.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-sans);
  font-variant-numeric: tabular-nums;
  box-sizing: border-box;
  vertical-align: middle;
  pointer-events: none;
  user-select: none;
}

/* ─── Dot ─── */

.dot {
  composes: badge;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: var(--md-error);
}

/* ─── Count ─── */

.count {
  composes: badge;
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  border-radius: var(--shape-full);
  font-weight: 600;
  background: var(--md-error);
  color: var(--md-on-error);
}

.tone-neutral {
  background: var(--md-surface-container-low);
  color: var(--md-on-surface-variant);
}

/* ─── Status ─── */

.status {
  composes: badge;
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
  padding: 0.125rem var(--space-2);
  border-radius: var(--shape-full);
}

.status-unavailable {
  composes: status;
  color: var(--status-unavailable);
  background: var(--status-unavailable-container);
}

.status-vaulted {
  composes: status;
  color: var(--status-vaulted);
  background: var(--status-vaulted-container);
}

.status-pending {
  composes: status;
  color: var(--status-pending);
  background: var(--status-pending-container);
}

.status-critical {
  composes: status;
  color: var(--status-critical);
  background: var(--status-critical-container);
}

.status-success {
  composes: status;
  color: var(--status-success);
  background: var(--status-success-container);
}

.status-featured {
  composes: status;
  color: var(--status-featured);
  background: var(--status-featured-container);
}

.status-info {
  composes: status;
  color: var(--status-info);
  background: var(--status-info-container);
}

.status-vip {
  composes: status;
  color: var(--status-vip);
  background: var(--status-vip-container);
}
